import React from "react";
import { useSelector } from "react-redux";
import FCRegistrationBanner from "./FCRegistrationBanner";
import { selectHasParentRegistration } from "../../../../../redux/slices/appSettingsSlice";
import { selectParentRegistration } from "../../../../../redux/slices/parentRegistrationSlice";

const ConnectedFCRegistrationBanner = () => {
    const hasParentRegistration = useSelector(selectHasParentRegistration);
    const parentRegistration = useSelector(selectParentRegistration);

    const fCRegistrationBannerProps = {
        hasParentRegistration,
        parentRegistration,
    };
    return <FCRegistrationBanner {...fCRegistrationBannerProps} />;
};

export default ConnectedFCRegistrationBanner;
